import { getThemeColor, type MantineTheme } from '@mantine/core'

/** Hex/rgb pass through; otherwise resolved as a Mantine palette key (e.g. `orange`, `yellow.4`). */
export function resolveBoggleAccentCssColor(accent: string, theme: MantineTheme) {
  return accent.startsWith('#') || accent.startsWith('rgb')
    ? accent
    : getThemeColor(accent, theme)
}
